import React, { memo } from 'react';
import colors from 'styles/themes/colors';

/**
 * This is a white rectangle to be used in a SVG parent.
 * By having a full-size background, you can make sure any
 * events in the SVG are caught.
 *
 * @method      Background
 * @param       {Object}  props React props
 * @param       {Number}  props.x The x-position of the background rect
 * @param       {Number}  props.y The y-position of the background rect
 * @param       {Number|String}  props.width The parent width
 * @param       {Number|String}  props.height The parent height
 * @param       {Number}  props.color The background color
 * @param       {Object}  props.presentational Other presentational attributes, (eg. fillOpacity)
 * @constructor
 */

interface IBackgroundProps {
  x?: number;
  y?: number;
  width: number | string;
  height: number | string;
  color?: string;
  fill?: string;
  fillOpacity?: string;
}

const Background: React.FC<IBackgroundProps> = (props) => {
  const { x = 0, y = 0, width, height, ...presentational } = props;
  delete presentational.color;

  // fr="45%"
  return (
    <>
      <defs>
        <radialGradient id="radial-gradient" cx="50%" cy="50%" r="75%">
          <stop offset="0%" stopColor={colors.White} />
          <stop offset="100%" stopColor={colors.LightGrey} />
        </radialGradient>
      </defs>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill={'url(#radial-gradient)'}
        {...presentational}
      />
    </>
  );
};

export default memo(Background);
